<template>
  <div>
    <transition name="modal-fade">
      <form method="post" @submit.prevent="createCustomer" @cancel="close">
        <div
          class="modal"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <Navbar />
          <section class="modal-body" id="modalDescription">
            <slot name="body">
              <div class="heading">
                <img
                  src="@/assets/left-arrow.png"
                  class="btn-close"
                  @click="close"
                />
              </div>

              <div id="customer-container">
                <div v-if="isLoaded">
                  <LoadingSpinner />
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <h3>Enter Customer Details</h3>
                  </div>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="First name *"
                      v-model="first_name"
                      required
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Last name *"
                      v-model="last_name"
                      required
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Email"
                      v-model="email"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <!-- <input
                    type="text"
                    class="form-control"
                    placeholder="Date of birth *"
                    v-model="date_of_birth"
                  /> -->
                    <date-picker
                      v-model="date_of_birth"
                      placeholder="Date of birth"
                      :config="options"
                    ></date-picker>
                  </div>
                  <div class="form-group col-md-6">
                    <select class="form-control" v-model="gender" required>
                      <option value="">Select gender</option>
                      <option>Female</option>
                      <option>Male</option>
                      <option>Other</option>
                    </select>
                  </div>
                </div>
                <div class="row" id="book-appointment">
                  <div class="col-md-12">
                    <button class="btn btn-book" type="submit">
                      Book Appointment
                    </button>
                  </div>
                </div>
                <Success
                  v-if="completeBooking"
                  @close="completeBooking = false"
                />
              </div>
            </slot>
          </section>
        </div>
      </form>
    </transition>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import Navbar from "@/views/Layouts/Navbar.vue";
import LoadingSpinner from "@/components/Utilities/LoadingSpinner.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";
// import moment from "moment";
import Success from "./Success.vue";

export default {
  name: "success",
  components: {
    Navbar,
    LoadingSpinner,
    datePicker,
    Success
  },
  props: [
    "team_id",
    "date",
    "time",
    "appointment_notes",
    "service_id",
    "phone_number"
  ],
  data() {
    return {
      business_id: localStorage.getItem("business_id"),
      completeBooking: false,
      isLoaded: false,
      first_name: "",
      last_name: "",
      email: "",
      gender: "",
      customer_id: "",
      date_of_birth: new Date(),
      options: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        keepOpen: false
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    createCustomer() {
      this.isLoaded = true;
      axios
        .post(this.$hostname + "/createCustomer", {
          first_name: this.first_name,
          last_name: this.last_name,
          phone_number: this.phone_number,
          email: this.email,
          sex: this.gender,
          date_of_birth: this.date_of_birth
        })
        .then(response => {
          this.customer_id = response.data.data.id;
          this.isLoaded = false;
          this.createAppointment();
        })
        .catch(error => {
          this.isLoaded = false;
          alert("an error occured, please try again");
          console.log(error);
        });
    },
    createAppointment() {
      this.isLoaded = true;
      axios
        .post(this.$hostname + "/createappointment", {
          customer_id: this.customer_id,
          business_id: this.business_id,
          service_id: this.service_id,
          team_id: this.team_id,
          appointment_notes: this.appointment_notes,
          date: this.date,
          time: this.time
        })
        .then(response => {
          console.log(response.data.message);
          this.completeBooking = true;
          this.isLoaded = false;
        })
        .catch(error => {
          this.isLoaded = false;
          alert("an error occured, please try again");
          console.log(error);
        });
    }
  },
  mounted() {
    this.date_of_birth = null;
  }
};
</script>

<style scoped>
.modal {
  background: #ffffff;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  /* To make the modal full screen, remove the code below and vice varsa*/
  /* top: 58px; */
}
.modal-body {
  position: relative;
  padding: 20px 10px 20px 10px;
  overflow: auto;
}
.heading {
  padding-bottom: 20px;
  text-align: left;
}
#customer-container {
  margin: 20px 25% 0px 25%;
}
#customer-container h3 {
  color: #3a3e46;
  font-size: 29px;
  font-weight: bold;
  margin-bottom: 33px;
  text-align: left;
}
#customer-container input,
#customer-container select {
  height: 50px;
  margin-bottom: 20px;
}
#book-appointment {
  text-align: center;
}
.btn-book {
  background: #be2532;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  width: 200px;
  height: 49px;
  top: 90%;
  position: relative;
  margin-bottom: 100px;
}
</style>
